import {Component} from '@angular/core';

@Component({
    selector: 'wba-dokument-schwaerzen-dialog',
    template: `
    <wba-modal-dialog headerTitle="Dokument schwärzen" targetId="DokumentSchwaerzen_Dialog_Nachweise">
      <div id="DokumentSchwaerzen_Nachweise_Text">
        <p id="DokumentSchwaerzen_Text1">Sie können die Dokumente stellenweise schwärzen. Achten Sie bitte darauf, dass die für
          das Jobcenter erforderlichen Stellen lesbar bleiben.</p>
        <p id="DokumentSchwaerzen_Nachweise_Text2">Ein Dokument wird nur zur Akte genommen, wenn dem Dokument Tatsachen zu
          entnehmen sind,
          die sich unmittelbar auf die Anspruchsvoraussetzungen der von Ihnen beantragten Leistungen nach dem <span
            class="text-nowrap">SGB II</span>
          auswirken.</p>
      </div>
    </wba-modal-dialog>
  `,
    standalone: false
})
export class DokumentSchwaerzenDialogComponent {

}
